<div>
  <div bsModal #setDatesModal="bs-modal" class="modal" tabindex="-1" role="dialog" style="wisdth: 200px">
    <div class="modal-dialog modal-sm" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Set Deadlines</h4>
        </div>
        <div class="modal-body">
          <form [formGroup]="addDateForm">
            <div class="form-group">
              <label for="name" style="margin-bottom: 0">Recommended Action</label>
              <div>
                <button
                  (click)="setDeadline('+30d', 'violationRecommendedDeadline')"
                  type="button"
                  class="btn btn-sm btn-link"
                  style="padding: 3px 10px">
                  30 days
                </button>
                <button
                  (click)="setDeadline('+60d', 'violationRecommendedDeadline')"
                  type="button"
                  class="btn btn-sm btn-link"
                  style="padding: 3px 10px">
                  60 days
                </button>
                <button
                  (click)="setDeadline('+90d', 'violationRecommendedDeadline')"
                  type="button"
                  class="btn btn-sm btn-link"
                  style="padding: 3px 10px">
                  90 days
                </button>
              </div>
              <app-datepicker-input
                [validationStyle]="false"
                [formControl]="addDateForm.get('violationRecommendedDeadline')"></app-datepicker-input>
            </div>

            <div class="form-group">
              <label for="name" style="margin-bottom: 0">Action Required</label>
              <div>
                <button
                  (click)="setDeadline('+30d', 'violationActionRequiredDeadline')"
                  type="button"
                  class="btn btn-sm btn-link"
                  style="padding: 3px 10px">
                  30 days
                </button>
                <button
                  (click)="setDeadline('+60d', 'violationActionRequiredDeadline')"
                  type="button"
                  class="btn btn-sm btn-link"
                  style="padding: 3px 10px">
                  60 days
                </button>
                <button
                  (click)="setDeadline('+90d', 'violationActionRequiredDeadline')"
                  type="button"
                  class="btn btn-sm btn-link"
                  style="padding: 3px 10px">
                  90 days
                </button>
              </div>
              <app-datepicker-input
                [validationStyle]="false"
                [formControl]="addDateForm.get('violationActionRequiredDeadline')"></app-datepicker-input>
            </div>
          </form>
          <br />

          <div style="text-align: right">
            <button type="button" class="btn btn-secondary" (click)="cancel()">Close</button>&nbsp;
            <button type="button" class="btn btn-primary" (click)="save()">Save changes</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
